import { createSelector } from 'reselect'

// get the step from the step number of the cycle of
// a given length
// Returns undefined if theres nothing to play
// Otherwise it returns the transpose to play
const getDiv = (
    cycle,
    stepNumber,
    length, // the cycle length (of the current cycle)
    c=0, // counts how far into the cycle we are
    cycleNumber, // the iteration of the cycle (used for / operator),
    outputNumber=0
) => {
    // divide the cycle into cycle.length many parts each with length=div (of steps)
    let div = length / cycle.length; 
    let i = 0; 
    let triggers = [];
    for (; i < cycle.length; i++) {
       if (cycle[i] !== null &&
            Array.isArray(cycle[i])) {
            if (stepNumber >= Math.floor(c) && stepNumber < c + div) { 
                getDiv(cycle[i], stepNumber, div, c, cycleNumber).forEach(
                    trigger => triggers.push(trigger));
            }
       } else if (cycle[i] && cycle[i].cycle) {
           if (stepNumber >= c && stepNumber < c + div) {
               let shouldAdd = true;
               if (cycle[i].operator === '/') {
                   shouldAdd = cycleNumber % cycle[i].operand === 0;
               }
               if (shouldAdd) {
                   let outputNumber = cycle[i].operator === "^" ? cycle[i].operand : 0;
                   getDiv(cycle[i].cycle, stepNumber, div, c, cycleNumber, outputNumber).forEach(
                       trigger => triggers.push(trigger));
               }
           }
       } else {
           if (stepNumber == Math.floor(c)) {
               let shouldAdd = true;
               if (cycle[i].operator === '/') {
                   shouldAdd = cycleNumber % cycle[i].operand === 0;
               } 
               if (shouldAdd) {
                   triggers.push({
                       transpose: cycle[i].transpose,
                       outputNumber: cycle[i].operator === '^' ? cycle[i].operand : outputNumber,
                       offset: c - Math.floor(c),
                       duration: div / 2,
                       cycle: cycle[i].id
                   });
               }
           }
       }
        c+=div;
    }
    return triggers;
};

const getCycle = state => state.cycle;
const getStepNumber = state => state.stepNumber;
const getLength = state => state.length;

// memoize so that we dont need to recalculate for
// same input
// TODO: once we have nondeterministic cycles, we
// will need to make sure the cycle is deterministic
// before using the memoized function
export const getStep = 
    createSelector(
        getCycle,
        getStepNumber,
        getLength,
        (cycle, stepNumber, length) => 
            getDiv(
                expandCycle(cycle),
                stepNumber % length,
                length,
                0,
                Math.floor(stepNumber / length))
        );


export const expandCycle = (cycle) => {
    let expanded = [];
    for (let i in cycle) {
        if (Array.isArray(cycle[i])) {
            expanded.push(expandCycle(cycle[i]));
        } else {
            expanded = [... expanded, ...expandLeaf(cycle[i])];
        }
    }
    return expanded;
};

// returns a list to be concatenated onto the expanded cyccle
// if thers a star operand, it expands it
const expandLeaf = (leaf) => {
    let toExpand = undefined;
    let {operator, operand, transpose, cycle} = leaf;
    if (cycle) {
        toExpand = expandCycle(cycle);
    } else {
        toExpand = leaf;
    }

    if (operator === '*') {
        let expanded = [];
        for (let i=0; i < operand; i++) {
            expanded.push(toExpand);
        }
        return expanded;
    }
    return [leaf];
}

